import { useQuery } from '@tanstack/react-query';
import { jobApiClient } from 'src/api/FiretrolApiClientInstances';
import { queryKeys } from 'src/api/queries/queryKeys';
import { toCancelToken } from 'src/api/queries/queryClient';

/** @registry Archived jobs, shown on the Jobs page's Archived tab. */
export function useClosedJobs() {
  return useQuery({
    queryKey: queryKeys.jobs.closedList(),
    queryFn: ({ signal }) => jobApiClient.getClosedJobs(toCancelToken(signal)),
    staleTime: 30_000,
    meta: { errorContext: 'archived jobs' },
  });
}
